import xmljson from 'xmljson';

const convertJsonObjectsIntoArrays = (rssItem) => {
    if (rssItem.channel && (typeof rssItem.channel) !== 'string') {
        rssItem.channel = (Object.keys(rssItem.channel).map((key) => rssItem.channel[key]));
    }
    if (rssItem.state && (typeof rssItem.state) !== 'string') {
        rssItem.state = (Object.keys(rssItem.state).map((key) => rssItem.state[key]));
    }
    if (rssItem.category && (typeof rssItem.category) !== 'string') {
        rssItem.category = (Object.keys(rssItem.category).map((key) => rssItem.category[key]));
    }
    rssItem.pubDate = new Date(rssItem.pubDate);
};

const handleConversionFromJsonToXml = (convertedJson, data) => {
    convertedJson = data;
    let items = convertedJson.rss.channel.item;
    items = (Object.keys(items).map((key) =>items[key]));
    items.forEach((rssItem) => {
        convertJsonObjectsIntoArrays(rssItem);
    });
    return items;
};

const handleOnloadSuccess = (xml) => {
    let convertedJson;
    xmljson.to_json(xml, (error, data)=>{
        convertedJson = handleConversionFromJsonToXml(convertedJson, data);
    });
    return convertedJson;
};

const retrieveRSSDataFromFeed = (feedLink) => {
    return new Promise((resolve, reject)=> {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', feedLink, true);
        xhr.onload = () => {
            resolve(xhr.responseText);
        };
        xhr.onerror = () => {
            reject(Error(`Issue with call to feed ${xhr.status}`));
        };
        xhr.send();
    });
};

export default {
    retrieveRSSDataFromFeed: retrieveRSSDataFromFeed,
    handleOnLoad: handleOnloadSuccess
};